import classNames from 'classnames'
import React, { useState, useEffect } from 'react'
import { Controller } from 'react-hook-form'
import { Col, Icon, Message, Panel, Row, Uploader } from 'rsuite'
import { isValidators } from '../../utils/ValidatorUtils'
import { isEmpty } from 'lodash-es'
import { useForm } from 'react-hook-form/dist/index.ie11'
import AppContext from '../../context/AppContext'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import ViewButton from '../../components/buttons/viewButton/ViewButton'
import notification from '../../utils/notification'
import ConfirmWidget from '../confirm/ConfirmWidget'

export default function ContractFormAttra({
  schema,
  onDownload = () => {},
  onUpload = () => {},
  ...props
}) {
  const [formSchema, setFormSchema] = useState()
  const [uploadFile, setUploadFile] = useState()
  const { register, handleSubmit, errors, control, setValue, clearErrors, getValues } = useForm()
  const [isShowConfirm, setIsShowConfirm] = useState(false)

  const defaultSupportType = '.jpg, .jpeg, .png, .pdf'

  const { theme } = React.useContext(AppContext)
  useEffect(() => {
    console.log('schema', schema)
    setFormSchema(schema)
  }, [schema])

  return (
    <>
      {formSchema && (
        <Panel
          header={formSchema.header}
          bordered
          collapsible
          defaultExpanded
          shaded
          style={{ marginBottom: 20 }}
        >
          <Row>
            <Message
              showIcon
              type="info"
              description={`ชนิดที่รองรับ : ${formSchema.attachment.fileType || defaultSupportType} ${
                formSchema.attachment.fileSize && formSchema.attachment.fileSize > 0
                  ? `, ขนาดไฟล์ไม่เกิน ${formSchema.attachment.fileSize} MB`
                  : ''
              }`}
            />
            <Col xs={24} sm={24} md={24} lg={24}>
              <Controller
                name={'attachment'}
                control={control}
                defaultValue={
                  !isEmpty(formSchema.attachment.value) ? [formSchema.attachment.value] : undefined
                }
                rules={isValidators(formSchema.attachment.validators)}
                render={(props) => {
                  return (
                    <>
                      <Uploader
                        draggable
                        accept={formSchema.attachment.fileType || defaultSupportType}
                        autoUpload={false}
                        fileList={props.value || []}
                        onChange={(fileList) => {
                          if (isEmpty(fileList)) {
                            props.onChange(undefined)
                          } else {

                            if (formSchema.attachment.fileSize && formSchema.attachment.fileSize > 0) {
                              let isSupportSize = true
                              isSupportSize = fileList[fileList.length - 1]?.blobFile.size <= formSchema.attachment.fileSize * 1024 * 1024
                              if(!isSupportSize){
                                notification.open('error', {
                                  title: `ขนาดไฟล์เกิน ${formSchema.attachment.fileSize} MB `,
                                  duration: 5000,
                                })
                                return
                              }
                            }

                            let files = []
                            files.push(fileList[fileList.length - 1])
                            props.onChange(files)

                            setUploadFile(files)
                          } 
                        }}
                      >
                        <div>
                          <div
                            style={{ lineHeight: '50px' }}
                            className={classNames('uploader', `${theme[0]}-background`)}
                          >
                            <Icon size="4x" icon="upload2" />
                            <small className="uploder__text">
                              <p style={{ wordBreak: 'break-word' }}>
                                คลิกหรือลากไฟล์มายังพื้นที่นี้เพื่ออัปโหลด
                              </p>
                            </small>
                          </div>
                        </div>
                      </Uploader>

                      <div className="right">
                        {formSchema.attachment.value?.path && (
                          <ViewButton
                            icon="download"
                            children="ดาวน์โหลดสัญญาที่ลงนามแล้ว"
                            style={{
                              marginRight: 10,
                              marginBottom: 10,
                            }}
                            onClick={() => {
                              if (formSchema?.attachment?.value?.path) {
                                onDownload(formSchema.attachment.value.path)
                              } else {
                                notification.open('error', {
                                  title: `ไม่พบไฟล์`,
                                  duration: 5000,
                                })
                              }
                            }}
                          />
                        )}

                        <SaveButton
                          children="อัพโหลดสัญญาที่ลงนามแล้ว"
                          onClick={() => setIsShowConfirm(true)}
                        />
                      </div>
                    </>
                  )
                }}
              />
            </Col>
          </Row>
        </Panel>
      )}

      <ConfirmWidget
        title={`ยืนยันการเปลี่ยนสถานะโครงการ`}
        show={isShowConfirm}
        detail={`ระบบจะเปลี่ยนสถานะโครงการเป็นดำเนินการ ยืนยันการเปลี่ยนสถานะโครงการเป็นดำเนินการใช่หรือไม่ ?`}
        onCancle={() => setIsShowConfirm(false)}
        onConfirm={() => {
          onUpload(uploadFile)
          setIsShowConfirm(false)
        }}
        size="md"
      />
    </>
  )
}
